import SecondaryButton from '../core/SecondaryButton';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import RefreshIcon from '@material-ui/icons/Refresh';
import { globalStyles as styles } from '../core/style/gstheme';

class QualityCheck extends React.Component {

    render() {

        const { title, issues, issueDisplay, message, dataTest, fromCache, classes, onRefresh, isLoading } = this.props;
        const pending = !issues && issues !== undefined;
        const delay = new Date(fromCache);
        const passed = issues === undefined;
        const sortedIssues = issues ?
            issues.sort((a, b) => {
                const aID = a.latestIRI || a.id;
                const bID = b.latestIRI || b.id;
                if (aID < bID) return -1;
                return 1;
            })
            :
            issues;

        return (
            <div data-test={dataTest} style={{ borderBottom: 'solid 1px #c5c5c5', paddingBottom: 24, marginBottom: 12 }}>
                {!passed && delay > 0 &&
                    <div data-test="refresh-info" style={{ float: 'right' }}><Typography className={classes.subHeading} style={{ marginBottom: 12 }}>
                        <span data-test="last-run" style={{ display: 'inline-block', marginRight: 12 }}>Last run at {delay.toLocaleString().substring(12)}</span>
                        {!isLoading && <SecondaryButton dataTest="refresh" onClick={onRefresh} endIcon={<RefreshIcon />}>Refresh</SecondaryButton>}
                    </Typography>
                    </div>
                }
                <Typography variant="subtitle2" style={{
                    marginTop: 20,
                    color: pending ?
                        '#212121'
                        : (!passed ?
                            '#DD2C00'
                            :
                            '#84BC01'
                        ),
                    fontSize: '16px'
                }}>{title}</Typography>
                {!pending && message && !passed && <Typography variant="body2" paragraph>{message}</Typography>}
                {!pending && !passed && issues && sortedIssues.map((issue, index) =>
                    <div data-test={"issue-" + index} key={index}>
                        {issueDisplay(issue, issues)}
                    </div>
                )}
                {pending && !passed && <Typography variant="body2" style={{ color: '#212121' }}>Pending</Typography>}
                {passed && <Typography data-test="no-issues" variant="body2" style={{ color: '#212121' }}>No issues.</Typography>}
            </div>
        );
    }
}

QualityCheck.propTypes = {
    dataTest: PropTypes.string,
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    fromCache: PropTypes.number,
    title: PropTypes.string.isRequired,
    issues: PropTypes.array,
    isLoading: PropTypes.bool.isRequired,
    onRefresh: PropTypes.func.isRequired,
    issueDisplay: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(QualityCheck);